import { z } from 'zod'

import { emailSchemaOptional } from '@/shared/lib/validation/email'
import { phoneSchema } from '@/shared/lib/validation/phone'

export const SlideSchema = z.object({
	ID: z.string(),
	SORT: z.string(),
	NAME: z.string(),
	DATE_CREATE: z.string(),
	IMG: z.string(),
	IMG_RETINA: z.string().nullable(),
	IMG_MOBILE: z.string(),
	LINK_VALUE: z.string(),
	OPEN_IN_NEW_WINDOW: z.boolean()
})

export type Slide = z.infer<typeof SlideSchema>

export type Shop = {
	B2B_SCHEME_IMAGE: null
	DESCRIPTION: string
	FULL_ADDRESS: string
	GPS_N: string
	GPS_S: string
	ID: string
	IMAGES: string[]
	MALL: string
	METRO: string
	METRO_LINE: string
	NAME: string
	PHONE: string
	REGION: string
	SCHEDULE: string
	SCHEME_IMAGE: string
	STORE_ID: string
	TEXT_DESCRIPTION: string
	TEXT_INFO: string
	UF_IS_SERVICE: string
	UF_IS_SHOP: string
	XML_ID: string
}

export const formSchema = z
	.object({
		recaptcha_response: z.string().nullable(),
		COMMENTS: z
			.string()
			.trim()
			.optional()
			.transform(value => value || 'Комментарий не заполнен'),
		LAST_NAME: z.string().trim().optional().nullable(),
		NAME: z
			.string({ required_error: 'Обязательное поле' })
			.min(2, { message: 'Необходимо минимум 2 символа' })
			.max(254, { message: 'Максимум 254 символа' })
			.trim(),
		EMAIL: emailSchemaOptional,
		PHONE: phoneSchema,
		USER_TYPE: z.union([z.literal('individual'), z.literal('legal')]),

		STORE_ID: z.string().optional().nullable()
	})
	.superRefine((data, ctx) => {
		const { USER_TYPE, STORE_ID } = data

		if (USER_TYPE === 'individual' && !STORE_ID) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Выберите сервисный центр',
				path: ['STORE_ID']
			})
		}

		if (USER_TYPE === 'individual' && STORE_ID) {
			if (!/\b[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\b/.test(STORE_ID)) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'Неверный формат STORE_ID',
					path: ['STORE_ID']
				})
			}
		}
	})

export type FormSchema = z.infer<typeof formSchema>
